<template>
    <div class="section-post-creator">
    
        <header>
            <div class="container-title">

                <div class="btn-back" @click="$router.push('/dash/planner');"></div>
                <div class="text">
                    <h2 class="title">{{title}}</h2>
                    <p v-if="!previewMode.active && mode == 'create'" class="switchOldVersion" @click="switchInterface">Passez à l'ancienne version</p>
                    <p v-else-if="mode !== 'create'" class="switchOldVersion" @click="$router.push('/dash/planner');">Retour au planner</p>
                </div>
               
            </div>
            <div class="custom-edtion-mode" v-if="!previewMode.active">
             
                <h5 @click="handleChangecustomMode(!customMode.active)">Mode personnalisation</h5>
        
                <ComponentSwitch :value="customMode.active" :onChange="(value)=>handleChangecustomMode(value)" :id="'switchEditionMode'"></ComponentSwitch>
                <p class="state-edition-mode" @click="handleChangecustomMode(!customMode.active)">
                    {{customMode.active ? 'activé' : 'désactivé' }}
                </p>

                <div class="tutorial" v-if="!customMode.active && showTutorial">
                    <svg width="29" height="31" viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.61478 29.4303C3.46662 10.3949 6.9428 1.2045 27.9404 0.99937M7.61478 29.4303L1.21998 23.77M7.61478 29.4303L12.2981 22.1357" stroke="#B64985" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Apporter des modifications uniquement<br> aux comptes sélectionnés.
                </div>
            </div>
            <div class="btns-action">

                <template v-if="!previewMode.active">
                    <div class="btn-outline-primary" @click="saveDraft">{{{ create : 'Mise en brouillon',duplicate : 'Mise en brouillon', edit: 'Convertir en brouillon', draft : 'Enregistrer'}[mode || 'create']}}</div>
                    <div class="btn-secondary icon-r " @click="()=>handlerChangePreviewDisplay(true)">{{ textSwitchPreview }}<i class="fa-solid fa-arrow-right"></i></div>
                </template>

                <template v-else>
                    <div class="btn-outline-primary" @click="()=>handlerChangePreviewDisplay(false)">Retour</div>
                    <div v-if="textBtnFinish" class="btn-secondary icon-r " @click="sendPostAllPost">{{textBtnFinish}}<i class="fa-solid fa-arrow-right"></i></div>
                    <div v-else  class="btn-secondary icon-r disable">{{textSwitchPreview}}<i class="fa-solid fa-arrow-right"></i></div>
                </template>
                
            
            </div>
        </header>
        <div :class="'post-creator '+formShow" ref="postCreator" >
            <div class="container-form" v-if="formShow == 'formMultiple'">
                <div class="nav-type-post">
                    <div class="icon-l btn-primary"><i class="fa-solid fa-pen-to-square"></i>Standard</div>
                    <div v-if="pagesInstagramActivedShareStory.length" @click.stop="()=>switchTab('story_share')" class="icon-l"><i class="fa-solid fa-share-from-square"></i>Partage en story</div>
                    <div v-else class="icon-l" @click.stop="()=>switchTab('story')"  :class="{disable: pagesSelected.some(p=> p.network !== 'instagram')}"><i class="fa-solid fa-camera-retro"></i>Story</div>
                </div>
                <div class="container-form-scroll hide-scrollbar">
                    <div class="form">
                        <div class="list-pages-selected">
                            <div class="btn-add-page" :class="{retract: pagesSelected.length}" @click="openSelectPage">
                                <i class="fa-solid fa-plus"></i>
                                <p>Ajoutez des pages</p>
                            </div>
                            <div class="container-list-avatars hide-scrollbar">
                                <div class="list-avatars hide-scrollbar">
                                    <Avatar v-for="page in pagesSelected" :urlPicture="page.avatar" :typeNetwork="page.network" :key="page.id"></Avatar>
                                </div>
                            </div>
                        </div>          
                        <Form 
                            @setSelectTypeRenderNetwork="selectTypeNetwork" 
                            @addFile="(...args)=>this.$emit('addFile',...args)"
                            :files="files"
                            :typeRenderNetworkSelected="typeNetworkSelected"
                            :formData="formData"
                            :networksSelected="networksSelected"
                            >
                        </Form> 
                    </div>
                </div>
            </div>
            
            <div class="container-phone" ref="containerPhone">
                <div class="nav-type-network" v-if="!customMode.active">
                    <div class="list-network">
                        <Tooltip v-if="networksSelected.has('facebook')" :text="postNetworkIsValid.facebook.error.length ? postNetworkIsValid.facebook.error[0].textError : ''" :active="!postNetworkIsValid.facebook.showRender" position="left">
                            <div class="network" :class="{active: typeNetworkSelected == 'facebook', disable : !postNetworkIsValid.facebook.showRender}" @click="selectTypeNetwork('facebook')">
                                <Tooltip v-if="saveAllFormData.networks.facebook && postNetworkIsValid.facebook.showRender && Object.keys(saveAllFormData.networks.facebook).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'facebook'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-facebook"></i>
                            </div>
                        </Tooltip>     
                        <Tooltip v-if="networksSelected.has('instagram')" :text="postNetworkIsValid.instagram.error.length ? postNetworkIsValid.instagram.error[0].textError : ''" :active="!postNetworkIsValid.instagram.showRender" position="left">     
                            <div class="network" :class="{active: typeNetworkSelected == 'instagram', disable : !postNetworkIsValid.instagram.showRender}" @click="selectTypeNetwork('instagram')">
                                <Tooltip v-if="saveAllFormData.networks.instagram && postNetworkIsValid.instagram.showRender && Object.keys(saveAllFormData.networks.instagram).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'instagram'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-instagram" ></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('linkedin')" :text="postNetworkIsValid.linkedin.error.length ? postNetworkIsValid.linkedin.error[0].textError : ''" :active="!postNetworkIsValid.linkedin.showRender" position="left">    
                            <div class="network" :class="{active: typeNetworkSelected == 'linkedin', disable : !postNetworkIsValid.linkedin.showRender}" @click="selectTypeNetwork('linkedin')">
                                <Tooltip v-if="saveAllFormData.networks.linkedin && postNetworkIsValid.linkedin.showRender && Object.keys(saveAllFormData.networks.linkedin).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'linkedin'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-linkedin-in"></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('google')" :text="postNetworkIsValid.google.error.length ? postNetworkIsValid.google.error[0].textError : ''" :active="!postNetworkIsValid.google.showRender" position="left">    
                            <div class="network" :class="{active: typeNetworkSelected == 'google', disable : !postNetworkIsValid.google.showRender}" @click="selectTypeNetwork('google')">
                                <Tooltip v-if="saveAllFormData.networks.google && postNetworkIsValid.google.showRender && Object.keys(saveAllFormData.networks.google).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'google'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-google"></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('threads')" :text="postNetworkIsValid.threads.error.length ? postNetworkIsValid.threads.error[0].textError : ''" :active="!postNetworkIsValid.threads.showRender" position="left">    
                            <div class="network threads" :class="{active: typeNetworkSelected == 'threads', disable : !postNetworkIsValid.threads.showRender}" @click="selectTypeNetwork('threads')">
                                <Tooltip v-if="saveAllFormData.networks.threads && postNetworkIsValid.threads.showRender && Object.keys(saveAllFormData.networks.threads).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'threads'); }">
                                    
                                </Tooltip>
                                <svg aria-label="Threads" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path class="x19hqcy" d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"/></svg>
                            </div>
                        </Tooltip>     
                        <Tooltip v-if="networksSelected.has('twitter')" :text="postNetworkIsValid.twitter.error.length ? postNetworkIsValid.twitter.error[0].textError : ''" :active="!postNetworkIsValid.twitter.showRender" position="left">
                            <div class="network" :class="{active: typeNetworkSelected == 'twitter', disable : !postNetworkIsValid.twitter.showRender}"  @click="selectTypeNetwork('twitter')">
                                <Tooltip v-if="saveAllFormData.networks.twitter && postNetworkIsValid.twitter.showRender && Object.keys(saveAllFormData.networks.twitter).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'twitter'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-twitter"></i>
                            </div>
                        </Tooltip>   
                        <Tooltip v-if="networksSelected.has('tiktok')" :text="postNetworkIsValid.tiktok.error.length ? postNetworkIsValid.tiktok.error[0].textError : ''" :active="!postNetworkIsValid.tiktok.showRender" position="left">  
                            <div class="network" :class="{active: typeNetworkSelected == 'tiktok', disable : !postNetworkIsValid.tiktok.showRender}" @click="selectTypeNetwork('tiktok')">
                                <Tooltip v-if="saveAllFormData.networks.tiktok && postNetworkIsValid.tiktok.showRender && Object.keys(saveAllFormData.networks.tiktok).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'tiktok'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-tiktok"></i>
                            </div>
                        </Tooltip>  
                        <Tooltip v-if="networksSelected.has('youtube')" :text="postNetworkIsValid.youtube.error.length ? postNetworkIsValid.youtube.error[0].textError : ''" :active="!postNetworkIsValid.youtube.showRender" position="left">   
                            <div class="network" :class="{active: typeNetworkSelected == 'youtube', disable : !postNetworkIsValid.youtube.showRender}" @click="selectTypeNetwork('youtube')">
                                <Tooltip v-if="saveAllFormData.networks.youtube && postNetworkIsValid.youtube.showRender && Object.keys(saveAllFormData.networks.youtube).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'youtube'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-youtube"></i>
                            </div>
                        </Tooltip> 
                        <Tooltip v-if="networksSelected.has('pinterest')" :text="postNetworkIsValid.pinterest.error.length ? postNetworkIsValid.pinterest.error[0].textError : ''" :active="!postNetworkIsValid.pinterest.showRender" position="left">    
                            <div class="network" :class="{active: typeNetworkSelected == 'pinterest', disable : !postNetworkIsValid.pinterest.showRender}" @click="selectTypeNetwork('pinterest')">
                                <Tooltip v-if="saveAllFormData.networks.pinterest && postNetworkIsValid.pinterest.showRender && Object.keys(saveAllFormData.networks.pinterest).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'pinterest'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-pinterest"></i>
                            </div>
                        </Tooltip>  
                        <Tooltip v-if="networksSelected.has('telegram')" :text="postNetworkIsValid.telegram.error.length ? postNetworkIsValid.telegram.error[0].textError : ''" :active="!postNetworkIsValid.telegram.showRender" position="left">   
                            <div class="network" :class="{active: typeNetworkSelected == 'telegram', disable : !postNetworkIsValid.telegram.showRender}" @click="selectTypeNetwork('telegram')">
                                <Tooltip v-if="saveAllFormData.networks.telegram && postNetworkIsValid.telegram.showRender && Object.keys(saveAllFormData.networks.telegram).length > 0" :text="'Voir les modifications apportées'" position="right" :classCustom="'icon-edited'" @click="()=>{ handleChangecustomMode(true, 'telegram'); }">
                                    
                                </Tooltip>
                                <i class="fa-brands fa-telegram"></i>
                            </div>
                        </Tooltip>     

                    </div>
                </div>

                <!-- switch entre post standard ou parte en story dans la preview -->
                <div class="switch-preview-post-type" v-if="previewMode.active && previewMode.pageSelected && previewMode.pageSelected.network == 'instagram' && pagesInstagramActivedShareStory.some((page) => page.id == previewMode.pageSelected.id)">
                    <div class="btn-primary">Standard</div>
                    <div class="" @click.stop="()=>$emit('changeTab','story_share')">Story</div>
                </div>

                <Phone :firstPlan="phoneIsFirstPlan">
                    <renderPostFailed 
                        v-if="textPostFailed" 
                        :textError="textPostFailed"
                    />

                    <renderPostFacebook v-if="typeNetworkSelected == 'facebook'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'facebook').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :modes="modes"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.facebook && formData.formDataNetwork.facebook.snippet ? formData.formDataNetwork.facebook.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                        :place="formData.formDataNetwork && formData.formDataNetwork.facebook && formData.formDataNetwork.facebook.place ? formData.formDataNetwork.facebook.place : undefined"
                        :positionFormOverlay="customMode.active ? 'right' : 'left'"
                    />

                    <renderReelInstagram v-else-if="typeNetworkSelected == 'instagram' && formData.files && formData.files.length == 1 && ['video/mp4'].includes(files[formData.files[0].id].info.type)" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'instagram').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :musicName="'euro 2024 • Audio d\'origine'" 
                        :description="'This save 🤯 ... '"
                        :modes="modes" 
                        :mentions = "formData.mentions ? formData.mentions : {}"
                        :personsIdentified="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.personsIdentified ? formData.formDataNetwork.instagram.personsIdentified  : []"
                        :collaborators="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.collaborators ? formData.formDataNetwork.instagram.collaborators : []"
                        :positionFormOverlay="customMode.active ? 'right' : 'left'"
                        :music="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.music ? formData.formDataNetwork.instagram.music : undefined"
                        :place="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.place ? formData.formDataNetwork.instagram.place : undefined"
                    />

                    <renderPostInstagram v-else-if="typeNetworkSelected == 'instagram'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'instagram').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false" 
                        :modes="modes" 
                        :personsIdentified="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.personsIdentified ? formData.formDataNetwork.instagram.personsIdentified  : []"
                        :collaborators="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.collaborators ? formData.formDataNetwork.instagram.collaborators : []"
                        :place="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.place ? formData.formDataNetwork.instagram.place : undefined"
                        :music="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.music ? formData.formDataNetwork.instagram.music : undefined"
                        :ratio="formData.formDataNetwork && formData.formDataNetwork.instagram && formData.formDataNetwork.instagram.ratio ? formData.formDataNetwork.instagram.ratio : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                        :positionFormOverlay="customMode.active ? 'right' : 'left'"
                    />

                    <renderPostLinkedin v-else-if="typeNetworkSelected == 'linkedin'" 

                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :survey="formData.formDataNetwork && formData.formDataNetwork.linkedin && formData.formDataNetwork.linkedin.survey && formData.formDataNetwork.linkedin.survey.active ?  formData.formDataNetwork.linkedin.survey : null"
                        :titlePdf="formData.formDataNetwork && formData.formDataNetwork.linkedin && formData.formDataNetwork.linkedin.pdf && formData.formDataNetwork.linkedin.pdf.title ?  formData.formDataNetwork.linkedin.pdf.title : null"
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'linkedin').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.linkedin && formData.formDataNetwork.linkedin.snippet && !formData.formDataNetwork.linkedin.survey.active ? formData.formDataNetwork.linkedin.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderPostThreads  v-else-if="typeNetworkSelected == 'threads'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]"
                        :pageName="getNamePageNetwork" 
                        :pageName2="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'threads').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.urlsTextContent.length ?
                                !formData.files.find(f => ['video','image'].includes(files[f.id].info.type2)) ?
                                    {link: formData.urlsTextContent[0]} 
                                    : {}
                            : formData.formDataNetwork && formData.formDataNetwork.threads && formData.formDataNetwork.threads.snippet ? 
                                formData.formDataNetwork.threads.snippet 
                                : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />
        
                    <renderPostTwitter v-else-if="typeNetworkSelected == 'twitter'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :pageName2="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'twitter').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.twitter && formData.formDataNetwork.twitter.snippet ? formData.formDataNetwork.twitter.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />
                    
                    <renderPostTiktok v-else-if="typeNetworkSelected == 'tiktok'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'tiktok').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :musicName="'euro 2024 • Audio d\'origine'" 
                        :description="'This save 🤯 ... '">
                    </renderPostTiktok>

                    <renderPostGoogle v-else-if="typeNetworkSelected == 'google'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'google').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.google && formData.formDataNetwork.google.snippet ? formData.formDataNetwork.google.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderPostTelegram v-else-if="typeNetworkSelected == 'telegram'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'telegram').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :text="textContentConverted" :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.urlsTextContent && formData.urlsTextContent.length ? {link: formData.urlsTextContent[0]}: undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderPostPinterest v-else-if="typeNetworkSelected == 'pinterest'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'pinterest').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :title="textContentConverted ? textContentConverted.slice(0, 100).split('<br>')[0] : undefined"
                        :text="textContentConverted ? textContentConverted.split('<br>').slice(1).join('<br>') : undefined"
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :snippet="formData.formDataNetwork && formData.formDataNetwork.pinterest && formData.formDataNetwork.pinterest.snippet ? formData.formDataNetwork.pinterest.snippet : undefined"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />

                    <renderShortYoutube v-else-if="typeNetworkSelected == 'youtube' && (!formData.files.find(file => files[file.id].info.type2 == 'video') || files[formData.files.find(file => files[file.id].info.type2 == 'video').id].info.aspectRatio == 0.5625)" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'youtube').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :musicName="'euro 2024 • Audio d\'origine'" 
                        :description="'This save 🤯 ... '"
                    />

                    <renderPostYoutube v-else-if="typeNetworkSelected == 'youtube'" 
                        :medias="filesSortByNetwork[typeNetworkSelected]" 
                        :pageName="getNamePageNetwork" 
                        :picturePages="(previewMode.active ? [previewMode.pageSelected] : (customMode.active && !customMode.selection.network) ? [customMode.selection.page] : pagesSelected).filter(p => p.network == 'youtube').map(p => ({id: p.id, avatar: p.avatar, iconEdited: saveAllFormData.pages[p.id] && Object.keys(saveAllFormData.pages[p.id]).length > 0 && !previewMode.active && (!customMode.active || !customMode.selection.page || customMode.selection.page.id !== p.id) ? true : false}))"
                        @clickPage="clickPageInRenderPost" 
                        :title="textContentConverted ? textContentConverted.slice(0, 100).split('<br>')[0] : undefined"
                        :text="textContentConverted ? textContentConverted.split('<br>').slice(1).join('<br>') : undefined"
                        :comment="textCommentConverted" 
                        :datePost="formData.planifiedDate ? formData.planifiedDate.timestamp : false"
                        :mentions = "formData.mentions ? formData.mentions : {}"
                    />
                    
                    <!-- overlay -->
                    <selectMention v-if="modes.includes('addMentionMode')" 
                        @close="removeMode" 
                        :position="customMode.active ? 'right' : 'left'"
                        :mentionData="dataMode.addMentionMode && dataMode.addMentionMode.mention ? dataMode.addMentionMode.mention : {}"
                        :idMention="dataMode.addMentionMode && dataMode.addMentionMode.idMention ? dataMode.addMentionMode.idMention : null"
                    />
                    <selectHashtag v-if="modes.includes('addHashtagMode')" 
                        @close="removeMode"
                        :position="customMode.active ? 'right' : 'left'"
                        :id="dataMode.addHashtagMode && dataMode.addHashtagMode.id ? dataMode.addHashtagMode.id : ''"
                    />
                </Phone>

                <div class="nav-page-standard" v-if="previewMode.active">
                    <div class="list-page hide-scrollbar">
                        <template v-for="(networkName, index) in listNetworkSort">
                            <div class="group" v-if="pagesSelected.some(p => p.network == networkName)" :key="networkName" :class="{'active': !customMode.active && customMode.selection.network && customMode.selection.network == networkName}">
                                <div class="network" 
                                    :class="{
                                        [networkName]:true, 
                                        edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                        failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                    }" 
                                >
                                    <Checkbox v-if="!previewMode.active && (!customMode.selection.network || customMode.selection.network !== networkName)" :isChecked="customMode.selection.network && customMode.selection.network == networkName" :add="selectNetworkForcustomMode" :isDisable="customMode.selection.network && customMode.selection.network == networkName" :prefexId="'networkcustomModePostCreator'+index" :id="networkName"></Checkbox>
                                </div>
                                <div class="list-avatar">
                                    <div class="container-avatar"
                                        v-for="page in pagesSelected.filter(p => p.network == networkName)" 
                                        :class="{
                                            checked: (previewMode.pageSelected && previewMode.pageSelected.id == page.id), 
                                            edited: !previewMode.active && saveAllFormData.pages[page.id] && Object.keys(saveAllFormData.pages[page.id]).length > 0,
                                            failed: previewMode.active && dataFormRequest[page.id] && dataFormRequest[page.id].error
                                        }"
                                        :key="page.id"
                                    >
                                        <Avatar 
                                            @click="()=>{
                                                $emit('changePreviewDisplay',true, page);
                                                toggleSelectPageForcustomMode(page);
                                            }" 
                                            :checkIsPossible="true" 
                                            :checked="(previewMode.pageSelected && previewMode.pageSelected.id == page.id)" 
                                            :urlPicture="page.avatar"
                                        />
                                    </div>
                                </div>
                            </div>   
                        </template>  
                    </div>
                </div>
                <div class="nav-page-standard" v-else="customMode.active">
                    <div class="list-page hide-scrollbar">
                        <template v-for="(networkName, index) in listNetworkSort">
                            <div class="group" v-if="pagesSelected.some(p => p.network == networkName)" :key="networkName" :class="{'active': !customMode.active && customMode.selection.network && customMode.selection.network == networkName}">
                                <div class="network" 
                                    :class="{
                                        [networkName]:true, 
                                        edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                        failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                    }" 
                                    @click="() => selectNetworkForcustomMode(networkName)"
                                >
                                    <Checkbox v-if="!previewMode.active && (!customMode.selection.network || customMode.selection.network !== networkName)" :isChecked="customMode.selection.network && customMode.selection.network == networkName" :add="selectNetworkForcustomMode" :isDisable="customMode.selection.network && customMode.selection.network == networkName" :prefexId="'networkcustomModePostCreator'+index" :id="networkName"></Checkbox>
                                </div>
                                <div class="list-avatar">
                                    <div class="container-avatar"
                                        v-for="page in pagesSelected.filter(p => p.network == networkName)" 
                                        :class="{
                                            checked: (customMode.selection.page && customMode.selection.page.id == page.id) || (customMode.selection.network && customMode.selection.network == networkName), 
                                            edited: !previewMode.active && saveAllFormData.pages[page.id] && Object.keys(saveAllFormData.pages[page.id]).length > 0,
                                            failed: previewMode.active && dataFormRequest[page.id] && dataFormRequest[page.id].error
                                        }"
                                        :key="page.id"
                                        >
                                        <Avatar @click="()=>toggleSelectPageForcustomMode(page)" 
                                            :checkIsPossible="true" 
                                            :checked="(customMode.selection.page && customMode.selection.page.id == page.id) || (customMode.selection.network && customMode.selection.network == networkName)" 
                                            :urlPicture="page.avatar"
                                        />
                                    </div>
                                </div>
                            </div>   
                        </template>  
                    </div>
                </div>
            </div>          

            <template v-if="formShow == 'formUnique'" >

                <div class="container-form">
                    <div class="container-form-scroll hide-scrollbar" style="align-items: flex-end">
                        <div class="form">
                            <Form 
                                :typeRenderNetworkSelected="customMode.selection.network ? customMode.selection.network : customMode.selection.page ? customMode.selection.page.network : typeNetworkSelected"
                                :idPageRenderNetworkSelected="customMode.selection.page && customMode.selection.page.id ? customMode.selection.page.id : null"
                                :formData="formData"
                                @addFile="(...args)=>this.$emit('addFile',...args)"
                                :files="files"
                                :uniqueNetworkForm="true"
                                :updateFormData="customMode.selection.network ? saveAllFormData.networks[customMode.selection.network] : customMode.selection.page ? saveAllFormData.pages[customMode.selection.page.id] : {}"
                                :networksSelected="networksSelected"
                                @setSelectTypeRenderNetwork="selectTypeNetwork" 
                                @saveFormData="()=> {console.log('test12 okok'); $emit('saveFormData', customMode.selection.network || customMode.selection.page)}"
                                @restoreFormData="(key)=> $emit('restoreFormData', key, customMode.selection.network || customMode.selection.page)"
                            />
                        </div>
                    </div>
                </div>
                <div></div>
            </template>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import store from './../../../store/index.js';
import ComponentSwitch from '../utils/switch.vue';
import Avatar from '../utils/avatar.vue';
import Checkbox from '../utils/checkbox.vue';
import Phone from './Phone.vue';
import Form from './Form.vue';
import selectMention from './formOverlay/selectMention.vue'
import selectHashtag from './formOverlay/selectHashtag.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

import renderPostFailed from "./renderPost/renderPostFailed.vue"
import renderPostInstagram from "./renderPost/postInstagram.vue"
import renderReelInstagram from "./renderPost/reelInstagram.vue"
import renderPostFacebook from "./renderPost/postFacebook.vue"
import renderPostTwitter from "./renderPost/postTwitter.vue"
import renderPostLinkedin from "./renderPost/postLinkedin.vue"
import renderPostTiktok from "./renderPost/postTiktok.vue"
import renderPostGoogle from "./renderPost/postGoogle.vue"
import renderPostTelegram from "./renderPost/postTelegram.vue"
import renderPostPinterest from "./renderPost/postPinterest.vue"
import renderPostYoutube from "./renderPost/postYoutube.vue"
import renderShortYoutube from "./renderPost/shortYoutube.vue"
import renderPostThreads from "./renderPost/postThreads.vue"

import { listNetworkSort } from './constante.js'
import { 
    postNetworkValidator,
    getFilesByNetwork,
    deepClone,
    mergeUpdates
} from './utils.js'

import postMixin from './../../mixins/Posts.vue'
import draftMixin from './../../mixins/Drafts.vue'


const draftConstante = {
    "multipleImages":[],
    "multipleMedias":[],
    "activeMentionsAutoReplace":true,
    "activeHashtagsAutoAdd":true,
    "validMentions":[],
    "mentionsAdded":[],
    "hashtagsAdded":[],
    "activePrefixSuffix":false,
    "layers":[],
    "carrouselRatio":1,
    "instagramTexts":[],
    "instagramTextsUpdater":[],
    "storyLinkText":"",
    "snippetTitle":"",
    "snippet":null,
    "carouselOrderDragElement":null,
    "poll":{"question":"","options":["",""],"duration":604800},
    "templateManual":null,
    "instagramLinkPosition":{"x":160,"y":440,"color":0},
    "highlightInstagram":null,
    "instagramBackgroundColor":null,
    "sharedStoryUrl":"",
    "storySharedVisual":null,
    "screenshot":null,
    "videoReel":true,
    "videoReelFB":false,
    "videos":"{\"twitter\":null,\"facebook\":null,\"facebook_reel\":null,\"linkedin\":null,\"instagram\":null,\"instagram_reel\":null,\"story\":null}",
    "location":null,
    "userTags":null,
    "storyVideo":false,
    "pollStory":null,
    "sliderStory":null,
    "musicStory":null,
    "gifsStory":[],
    "mentionsWidget":[],
    "filename":null,
    "videoname":null,
    "validHashtags":[],
    "storyMultiple":[],
    "shareAfterPost":false,
    "storificationData":{"link":null},
    "storyShareToFacebook":false,
    "compressedImages":[],
    "tiktokOptions":"{\"comment_disabled\":false,\"duet_disabled\":true,\"stitch_disabled\":true,\"privacy_level\":\"SELF_ONLY\"}",
    "youtubeOptions":"{\"notifySubscribers\":true,\"madeForKids\":false,\"privacy_level\":\"public\",\"category\":\"22\",\"tag\":\"\",\"tags\":[],\"playlist\":null}",
    "log":["{\"user\":{\"id\":\"a79437f2-b92a-4213-909e-a267a7accfb3\",\"name\":\"Guilloux Clementooo\",\"email\":\"clement@mashup-web.com\",\"avatar\":\"https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/09kcdi7v6b9n-1530533447961.jpg\"},\"isDraft\":true,\"created_at\":\"2024-10-17T18:47:35+02:00\"}"],
    "typePost": "standard",
}


export default {
    components: {
        ComponentSwitch,
        Phone,
        Form,
        Avatar,
        Checkbox,
        selectMention,
        selectHashtag,
        renderPostFailed,
        renderPostInstagram,
        renderReelInstagram,
        renderPostFacebook,
        renderPostTwitter,
        renderPostLinkedin,
        renderPostTiktok,
        renderPostGoogle,
        renderPostTelegram,
        renderPostPinterest,
        renderPostYoutube,
        renderShortYoutube,
        renderPostThreads,
        Tooltip
    },
    mixins: [postMixin, draftMixin],

    props: {
        mode: String,
        files: Object,
        formData: Object,
        saveAllFormData: Object,
        dataFormRequest: Object,
        previewMode: Object,
    },

    data() {
        return {
           
            listNetworkSort: listNetworkSort,
           

           
            customMode: {
                active : false,
                selection : {
                    network: null,
                    page: null
                }
             
            },

            formShow: "formMultiple",// pour l'annimation

            timeOutAnnimateForm: null,

            typeNetworkSelected: "", //pour le telphone donc renomer la variable
            

            // previewMode.active : false, //dois etre coté parent


            //la list mode est connu et modifiable par tout les interfaces Network et les deux formulaires 
            modes : [],
            dataMode : {},

            showTutorial : !localStorage.postCreatorCountUsecustomMode ? true : localStorage.postCreatorCountUsecustomMode < 3,

            pagesInstagramActivedShareStory: []
        }
    },

    mounted() {
        EventBus.$on('postCreatorAddMode', this.addMode);
        EventBus.$on('postCreatorRemoveMode', this.removeMode);
        this.updateTypeNetworkSelected()
        this.setPagesInstagramActivedShareStory()
    },

    methods: {
      
        ///////////// METHOD SWITCH MODE /////////////

        handleChangecustomMode(state, network = null, page = null) {
            this.$set(this.customMode, 'active' ,state)
            if (state) {
                if (!network || !page) network = this.typeNetworkSelected || [...this.networksSelected][0]
                console.log('test12 handleChangecustomMode',state)
                this.$emit("saveFormData")
                this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
                this.$refs.postCreator.style.transform = `translateX(calc(-100% + ${this.$refs.containerPhone.clientWidth}px))`
                
                if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)

                this.timeOutAnnimateForm = setTimeout(() => {
                    if (network) {
                        this.typeNetworkSelected = network
                        this.selectNetworkForcustomMode(network)
                    }else if (page) {
                        this.toggleSelectPageForcustomMode(page)
                    }
                    this.timeOutAnnimateForm = setTimeout(() => {
                        this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
                        this.$refs.postCreator.style.transform = ``
                        this.formShow = "formUnique"
                    }, 300);
                }, 200);

                if (!localStorage.postCreatorCountUsecustomMode || localStorage.postCreatorCountUsecustomMode < 3) {
                    if (!localStorage.postCreatorCountUsecustomMode) localStorage.setItem('postCreatorCountUsecustomMode', 1)
                    else localStorage.setItem('postCreatorCountUsecustomMode', localStorage.postCreatorCountUsecustomMode + 1)
                }

            }else{
                this.$refs.postCreator.classList.add('annimate-switch-edition-mode');
                this.$refs.postCreator.style.transform = `translateX(calc(100% - ${this.$refs.containerPhone.clientWidth}px))`
                if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)

                this.$nextTick(() => {
                    this.timeOutAnnimateForm = setTimeout(() => {
      
                        this.timeOutAnnimateForm = setTimeout(() => {
                            this.$refs.postCreator.classList.remove('annimate-switch-edition-mode');
                            this.$refs.postCreator.style.transform = ``
                            this.formShow = "formMultiple" //detruit le form de droite
                            this.$emit('generateFormData') //gerner le new form data le form de droite, si inverte le form de droite va vouloir save
                        }, 300);
                    }, 200);
                })
            }
        },

        async handlerChangePreviewDisplay(state) {
            if (state) {
                this.$emit('saveFormData', this.customMode.active ? this.customMode.page || this.customMode.network : null)
                this.generateStoryShare()
            }
            this.$emit('changePreviewDisplay',state)
        },

        selectNetworkForcustomMode(network) {
            if (this.previewMode.active) return
            this.$set(this.customMode.selection, 'page', null)
            this.$set(this.customMode.selection, 'network', network)
            this.typeNetworkSelected = network
            this.$emit('generateFormData',network)
        },

        toggleSelectPageForcustomMode(page) {
            //  this.$emit('saveFormData')
            this.$set(this.customMode.selection, 'network', null)
            this.$set(this.customMode.selection, 'page', page)
            this.typeNetworkSelected = page.network
            this.$emit('generateFormData',page)
        },

        clickPageInRenderPost(idPage) {
            const page = this.pagesSelected.find(p => p.id == idPage)
            if (page) {
                if (this.customMode.active) {
                    this.toggleSelectPageForcustomMode(page)
                }else{
                    this.handleChangecustomMode(true, null, page)
                }
            }
        },

        ///////////// METHOD NAVIGATION /////////////

        switchTab(tabName) {
            
            this.$emit('saveFormData', this.customMode.active ? this.customMode.page || this.customMode.network : null)
            if (tabName == 'story_share') {
                this.generateStoryShare()
                this.$emit('generateFormData')
            }else{
                if (this.pagesSelected.some(p=> p.network !== 'instagram')) return
            }
            this.$emit("changeTab",tabName)
        },
    
        selectTypeNetwork(typeNetwork) {
            if (!this.postNetworkIsValid[typeNetwork].showRender) return
            this.typeNetworkSelected = typeNetwork
        },

        openSelectPage() {
            this.$store.commit('selectPage/updateSelectPageListRetracted', false)
        },

        addMode(mode, data = {}) {
            if (!this.modes.includes(mode)) this.modes = [...this.modes,mode]
            this.$set(this.dataMode, mode, data)
        },

        removeMode(mode = 'all') {
            if (mode == 'all') {
                this.modes = []
                return
            }
            this.modes = this.modes.filter(v => v !== mode)
        },

        switchInterface() {
            localStorage.setItem('postCreatorInterfacePreference', 'old')
            this.$router.push({
                name: 'planner',
                params: {
                newPost: true
                }
            })
        },

        updateTypeNetworkSelected() {

            if (!this.typeNetworkSelected || !this.networksSelected.has(this.typeNetworkSelected) || (!this.postNetworkIsValid[this.typeNetworkSelected].showRender && !this.customMode.active)) {
                this.typeNetworkSelected = this.networksSelected.size ? 
                    this.listNetworkSort.find(n => this.networksSelected.has(n) && this.postNetworkIsValid[n].showRender) || '' 
                : ''
            }

            if (!this.typeNetworkSelected && this.networksSelected.size) {
                this.typeNetworkSelected = this.listNetworkSort.find(n => this.networksSelected.has(n))
            }
        },

        //////////// METHOD FOR FORMDATA ////////////


        ////////////////// SORT DATA //////////////////

        setPagesInstagramActivedShareStory() {
            console.log("setPagesInstagramActivedShareStory",JSON.parse(JSON.stringify(this.saveAllFormData)))
            let defaultActivedShareStory = this.customMode.active ? this.saveAllFormData.main.formDataNetwork.instagram.shareInStory : this.formData.formDataNetwork.instagram.shareInStory

            //regarde si la valeur de shareInStory dans la customisation de instagram
            let saveNetworkIsActiveStory = null

            if (
                this.saveAllFormData.networks &&
                this.saveAllFormData.networks['instagram'] && 
                this.saveAllFormData.networks['instagram'].formDataNetwork &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.hasOwnProperty('shareInStory')
            ) {
                saveNetworkIsActiveStory =  this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.shareInStory
            }
 
            this.pagesInstagramActivedShareStory = this.pagesSelected.filter(page => {

                let isActived
                if (page.network !== 'instagram') {
                    isActived = false
                }else if (this.saveAllFormData.pages[page.id] && 
                    this.saveAllFormData.pages[page.id].formDataNetwork && 
                    this.saveAllFormData.pages[page.id].formDataNetwork.instagram && 
                    this.saveAllFormData.pages[page.id].formDataNetwork.instagram.hasOwnProperty('shareInStory')
                ) {
                    isActived = this.saveAllFormData.pages[page.id].formDataNetwork.instagram.shareInStory
                }else if (saveNetworkIsActiveStory !== null) {
                    isActived = saveNetworkIsActiveStory
                }else{
                    isActived = defaultActivedShareStory
                }
                console.log("setPagesInstagramActivedShareStory",page.id,isActived)
                return isActived
               
            })
        },

        generateStoryShare() {
            this.setPagesInstagramActivedShareStory()
            console.log("generateStoryShare")
            const getTemplate = (time, fileId, typePost) =>{
                return {   
                    "storification":{
                        "0":{
                            // "background":{"color":"#8A7A54"},
                            "stickers":{
                                [time]:{
                                    "type":"post",
                                    "disableMove": true,
                                    "disableTransform": true,
                                    "isEditing":false,
                                    "position":{"x":50,"y":50},
                                    "transform":{"rotate":0,"scale":1},
                                    "data":{
                                        idFile: fileId,
                                        typePost: typePost
                                    },
                                    "id":time,
                                    "zIndex":12
                                }
                            }
                        }
                    }         
                }
            }
            //Permet de generer les storifications
            //si shareInStory dans le form main et si file alors story
            let files = []
            let time = Date.now()
            let template = null
            
            if (this.pagesInstagramActivedShareStory.length) {
                let formDataRef = deepClone(this.saveAllFormData.main)
                mergeUpdates(formDataRef,this.saveAllFormData.networks['instagram'])
                files = getFilesByNetwork(formDataRef.files, ['instagram'], formDataRef.formDataNetwork, this.files)['instagram']

                if (files.length) {
                    let refreshBackgroundColor = true
                    const typePost = files.length > 1 ? 'carousel' : files[0].info.type2 == 'video' ? 'reel' : 'simple'

                    template = getTemplate(time, files[0].id, typePost)
                    if(!this.saveAllFormData.main.storification) {
                        this.$set(this.saveAllFormData.main,'storification' , template.storification)
                    }else if(!this.saveAllFormData.main.storification[0]) {
                        this.$set(this.saveAllFormData.main.storification, 0 , template.storification[0])
                    }else if(!this.saveAllFormData.main.storification[0].stickers) {
                        this.$set(this.saveAllFormData.main.storification[0], 'stickers' , template.storification[0].stickers)
                    }else{
                        const stickerPost = Object.values(this.saveAllFormData.main.storification[0].stickers).find(sticker => sticker.type == 'post')
                        if (!stickerPost) {
                            this.$set(this.saveAllFormData.main.storification[0].stickers, time , template.storification[0].stickers[time])
                        }else{
                            if (this.saveAllFormData.main.storification[0].stickers[stickerPost.id].data.idFile == files[0].id) refreshBackgroundColor = false
                            this.$set(this.saveAllFormData.main.storification[0].stickers[stickerPost.id], 'data', {
                                'idFile': files[0].id,
                                'typePost': typePost
                            })
                        }
                    }

                    if (refreshBackgroundColor && files[0].info.averageColor) {
                        this.$set(this.saveAllFormData.main.storification[0].background, 'color', files[0].info.averageColor)
                    }
                }else{
                    try {
                        const stickerPost = Object.values(this.saveAllFormData.main.storification[0].stickers).find(sticker => sticker.type == 'post')
                        if (stickerPost) {
                            this.$delete(this.saveAllFormData.main.storification[0].stickers, stickerPost.id)
                        }
                    } catch (error) {
                        
                    }
                }

                Object.keys(this.saveAllFormData.pages).forEach(pageId => {
                    let pageIsActived = this.pagesInstagramActivedShareStory.some(page => page.id == pageId)
                    console.log(pageId,'pageIsActived',pageIsActived)
                    if (!pageIsActived) this.$delete(this.saveAllFormData.pages, pageId)
                })
                
                //custom page
                this.pagesInstagramActivedShareStory.forEach((page, index) => {
                    
                    try {
                        files = this.saveAllFormData.pages[page.id].files.filter(({id:idFile}) => (
                            ['video', 'image'].includes(this.files[idFile].info.type2) && this.files[idFile].info.type2 !== 'image/gif'
                        ))
                    } catch (error) {
                        files = null
                    }

                    if (files && files.length) {
                        let refreshBackgroundColor = true
                        const typePost = files.length > 1 ? 'carousel' : this.files[files[0].id].info.type2 == 'video' ? 'reel' : 'simple'

                        template = getTemplate(time+index, files[0].id, typePost)

                        if (!this.saveAllFormData.pages[page.id]) {
                            this.$set(this.saveAllFormData.pages, page.id, template)
                        }else if(!this.saveAllFormData.pages[page.id].storification) {
                            this.$set(this.saveAllFormData.pages[page.id],'storification' , template.storification)
                        }else if(!this.saveAllFormData.pages[page.id].storification[0]) {
                            this.$set(this.saveAllFormData.pages[page.id].storification, 0 , template.storification[0])
                        }else if(!this.saveAllFormData.pages[page.id].storification[0].stickers) {
                            this.$set(this.saveAllFormData.pages[page.id].storification[0], 'stickers' , template.storification[0].stickers)
                        }else{
                            const stickerPost = Object.values(this.saveAllFormData.pages[page.id].storification[0].stickers).find(sticker => sticker.type == 'post')
                            if (!stickerPost) {
                                this.$set(this.saveAllFormData.pages[page.id].storification[0].stickers, time, template.storification[0].stickers[time])
                            }else{
                                if (this.saveAllFormData.pages[page.id].storification[0].stickers[stickerPost.id].data.idFile == files[0].id) refreshBackgroundColor = false
                                this.$set(this.saveAllFormData.pages[page.id].storification[0].stickers[stickerPost.id], 'data', {
                                    'idFile': files[0].id,
                                    'typePost': typePost
                                })
                            }
                        }

                        if (refreshBackgroundColor && this.files[files[0].id].info.averageColor) {
                            if (!this.saveAllFormData.pages[page.id].storification[0].background) {
                                this.$set(this.saveAllFormData.pages[page.id].storification[0], 'background', {color: this.files[files[0].id].info.averageColor})
                            }else{
                                this.$set(this.saveAllFormData.pages[page.id].storification[0].background, 'color', this.files[files[0].id].info.averageColor)
                            }
                        }
                    }else{
                        try {
                            const stickerPost = Object.values(this.saveAllFormData.pages[page.id].storification[0].stickers).find(sticker => sticker.type == 'post')
                            if (stickerPost) {
                                this.$delete(this.saveAllFormData.pages[page.id].storification[0].stickers, stickerPost.id)
                            }
                        } catch (error) {
                            
                        }
                    }
                
                
                });
            }            
        },

        /////////////// SAVE - POSTING ///////////////
        
        saveDraft() {
            this.$emit('saveFormData', this.customMode.active ? this.customMode.page || this.customMode.network : null)
            this.$emit('saveDraft')
        },

        sendPostAllPost() {
            this.$emit('sendPostAllPost')
        }
    },

    computed: {
        console:()=> console,
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'];
        },

        networksSelected() {
            return new Set(this.$store.getters['selectPage/selectPagePageSelected'].map(p => p.network));
        },
       
        phoneIsFirstPlan() {
            let validmodes = ['addCollaboratorMode','addIdentifierMode','addPlaceMode', 'addMusicMode','addMentionMode','addHashtagMode']
            return validmodes.find(v => this.modes.includes(v)) ? true : false
        },

        textContentConverted() {
    
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
            if (!this.formData.textContent || regex.test( this.formData.textContent)) return ''
            
            return this.formData.textContent.replaceAll("\\n", '<br>')
        },

        textCommentConverted() {
            const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
            if (!this.formData.textComment || regex.test( this.formData.textComment)) return ''

            return this.formData.textComment ? this.formData.textComment.replaceAll("\\n", '<br>') : ''
        },

        getNamePageNetwork() {
            if (this.previewMode.active && this.previewMode.pageSelected) return this.previewMode.pageSelected.name
            if ((this.customMode.active) && this.customMode.selection.page ) return this.customMode.selection.page.name

            const page = this.pagesSelected.find(p => p.network == this.typeNetworkSelected)
            return page ? page.name : ''
        },

        filesSortByNetwork() {
            return getFilesByNetwork(this.formData.files, this.listNetworkSort, this.formData.formDataNetwork, this.files)
        },

        postNetworkIsValid() {
            const validator = postNetworkValidator(this.listNetworkSort,  this.filesSortByNetwork,  this.formData.formDataNetwork , this.textContentConverted)
            return validator
        },

        countDataFormRequestValid() {
            return Object.values(this.dataFormRequest).filter(form => !form.hasOwnProperty('error')).length
        },

        textBtnFinish() {
            const forms = Object.values(this.dataFormRequest);
            
            const postPlanified = forms.filter(form => !form.hasOwnProperty('error') && form["data[scheduled_date]"]);
            const postInstantly = forms.filter(form => !form.hasOwnProperty('error') && !form["data[scheduled_date]"]);
            
            if (postPlanified.length && postInstantly.length) {
                return "Publier & planifier";
            } else if (postPlanified.length) {
                return `Planifier sur ${postPlanified.length} page${postPlanified.length > 1 ? 's' : ''}`;
            } else if (postInstantly.length) {
                return `Publier sur ${postInstantly.length} page${postInstantly.length > 1 ? 's' : ''}`;
            }

            return '';
        },

        textSwitchPreview() {
            if (this.mode == 'edit') return "Appliquer"
            let postPlanified = false
            let postInstantly = false
            
            const formMain = !this.customMode.active ? this.formData : this.saveAllFormData.main

            for (let i = 0; i < this.pagesSelected.length; i++) {
                if (postPlanified && postInstantly) break;
                const page = this.pagesSelected[i];

                const formDataByPage = this.customMode.active && this.customMode.selection.page && this.customMode.selection.page.id == page.id ? this.formData : this.saveAllFormData.pages[page.id]
                const formDataByNetwork = this.customMode.active && this.customMode.selection.network == page.network ? this.formData : this.saveAllFormData.networks[page.network]
       

                if (formDataByPage && formDataByPage.planifiedDate) {
                    if (formDataByPage.planifiedDate.date || formDataByPage.planifiedDate.hours) {
                        postPlanified = true
                    }else {
                        postInstantly = true
                    }
                }else if(formDataByNetwork && formDataByNetwork.planifiedDate){
                    if (formDataByNetwork.planifiedDate.date || formDataByNetwork.planifiedDate.hours) {
                        postPlanified = true
                    }else {
                        postInstantly = true
                    }
                }else{

                    if (formMain.planifiedDate.date || formMain.planifiedDate.hours) {
                        postPlanified = true
                    } else {
                        postInstantly = true
                    }
                }
            }

            if (postPlanified && postInstantly) {
                return "Publier & planifier";
            } else if (postPlanified) {
                return `Planifier`;
            } else if (postInstantly) {
                return `Publier`;
            }

            return '';
        },

        textPostFailed () {

            if (!Object.values(this.postNetworkIsValid).some(obj => obj.showRender == true)) {
                return 'Veuillez ajouter un média, un contenu ou un lien.'
            }

            if (this.previewMode.active) {
                if (this.customMode.selection.page && this.customMode.selection.page.id && this.dataFormRequest[this.customMode.selection.page.id] && this.dataFormRequest[this.customMode.selection.page.id].error) {
                    return this.dataFormRequest[this.customMode.selection.page.id].error
                }
            }else{
                if (!this.customMode.active  && this.typeNetworkSelected && this.postNetworkIsValid[this.typeNetworkSelected] && !this.postNetworkIsValid[this.typeNetworkSelected].showRender) {
                    return this.postNetworkIsValid[this.typeNetworkSelected].error.length ? this.postNetworkIsValid[this.typeNetworkSelected].error[0].textError : ''
                }

                if (this.customMode.active) {
                    if (this.customMode.selection.network) {
                        if (!this.postNetworkIsValid[this.customMode.selection.network].showRender) return this.postNetworkIsValid[this.customMode.selection.network].error.length ? this.postNetworkIsValid[this.customMode.selection.network].error[0].textError : ''
                    }else if(this.customMode.selection.page && this.customMode.selection.page.network){
                        if (!this.postNetworkIsValid[this.customMode.selection.page.network].showRender) return this.postNetworkIsValid[this.customMode.selection.page.network].error.length ? this.postNetworkIsValid[this.customMode.selection.page.network].error[0].textError : ''
                    }
                }
            }

            return ''
        },

        title () {

            switch (this.mode) {
                case "edit":
                    return "Mode édition"
                case "draft":
                    return "Edition du brouillon"
            
                default:
                    return this.previewMode.active ? 'Prévisualisation' : 'Nouvelle publication'
                   
            }
           
           
        },

        shareInStoryActived() {
            return this.formData.formDataNetwork.instagram.shareInStory || (this.saveAllFormData.networks.instagram && this.saveAllFormData.networks.instagram.formDataNetwork &&this.saveAllFormData.networks.instagram.formDataNetwork.instagram.shareInStory)
        }
    },

    
    
    watch: {
        networksSelected(newValue, oldValue) {
            this.updateTypeNetworkSelected()
        },
        postNetworkIsValid(validator) {
            console.log('postNetworkIsValid changed')
            this.updateTypeNetworkSelected()
        },
        ["formData.textContent"](newValue, oldValue) {
            // if (this.customMode.active) this.$emit('saveFormData', this.customMode.selection.page || this.customMode.selection.network)
        },
        
        ["formData.formDataNetwork.instagram.shareInStory"]: {
            handler() {
                this.setPagesInstagramActivedShareStory()
            },
            immediate: true
        },

        ["previewMode.active"]: {
            handler(value, oldValue) {
                if (value) {
                    if (this.previewMode.pageSelected) this.toggleSelectPageForcustomMode(this.previewMode.pageSelected)

                    if (oldValue == undefined) {
                         this.formShow = `${this.customMode.active ? "preview-left" : "preview-right"} annimate-switch-preview-mode`
                    }else{
                        this.formShow = this.customMode.active ? "preview-left" : "preview-right"
                        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                        this.$nextTick(() => {
                            this.timeOutAnnimateForm = setTimeout(() => {
                                this.$refs.postCreator.classList.add('annimate-switch-preview-mode');
                            }, 500);
                        })
                    }
                    
                }else{
                    this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');
                    if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                    this.$nextTick(() => {
                        this.timeOutAnnimateForm = setTimeout(() => {
                            if (this.formShow.startsWith("preview-left")) {
                                this.formShow = "formUnique"
                            }else{
                                this.formShow = "formMultiple"
                            }
                        }, 1000);
                    })
                }
            },
            immediate: true
        }
    },

    

    beforeDestroy () {
        EventBus.$off('postCreatorAddMode', this.addMode);
        EventBus.$off('postCreatorRemoveMode', this.removeMode);
    }

}
</script>
